/**
 * City page
 */
class City{
    constructor(settings={}) {
        this.locked= false;

        this.calendarPeriods=null;
        this.calendarResults=null;
        this.selectedCategories=[];
    	this.settings = settings;
        this.initLayout();
    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

    initLayout() {
        var that = this;
        initTabs(true);

        // today
        this.initMap();
        this.getSelectedCategories();

        // calendar
        this.calendarPeriods = $('input[name="period"]', 'div#calendar');
        this.calendarResults = $('div#calendar-results', 'div#calendar');
        initCustomRadios('div#calendar .radio-tabs', function(n,v) { that.calendarPeriodClickHandler(v); });
        this.loadCalendarEvents(this.calendarPeriods.val());

        // featured
        this.featured = $('div.featured');

        if(this.featured.length) {
            this.featured.find('a.action').mousedown(function(e) {
                var button = $(this);
                var type = button.hasClass('rsvp') ? 'event' : 'host';

                if(e.which <= 2) {
                    if(button.hasClass('active')) {
                        tracking.featuredClick(type, button.data('id'), 'city_page');
                        window.open(button.data('href'), '_blank');
                    }
                    else {
                        if(type == 'event') {
                            profile.rsvp(button.data('id'), 1, true, function() {
                                button.addClass('active');
                            });
                        }
                        else {
                            profile.follow(button.data('id'), function() {
                                button.addClass('active');
                            });
                        }
                    }
                }
            });
        }

        // streams
        $('a', 'div.streams-tab').click(function() {
            $('html, body').animate({ scrollTop : $(this).offset().top - 100 }, { duration : 250, queue : false });
        });

        $('section.stream').each(function() {
            var eventsList = $('ul.events-list', $(this));
                eventsList.addClass('transition');
            var eventsCount = $('li', eventsList).length;

            if(eventsCount < 5) {
                $('nav.links', $(this)).remove();
            }
            else {
                var toggle = $('<a href="#" data-expanded="0"><strong>' + that.settings.translations.expandStream + '</strong></a>').appendTo($('nav.links', $(this)));

                toggle.click(function() {
                    if(!$(this).data('expanded')) {
                        eventsList.height(Math.ceil(eventsCount / 4) * 270 - 10);
                        $(this).html('<strong>' + that.settings.translations.collapseStream + '</strong>').data('expanded', 1);
                    }
                    else {
                        eventsList.height(260);
                        $(this).html('<strong>' + that.settings.translations.expandStream + '</strong>').data('expanded', 0);
                    }

                    return false;
                });
            }
        });
    }

    initMap() {
        if(this.locked) return;

        var that = this;
        this.lock();

        this.map = new Map({
            canvas: $('#city-map'),
            data: '/events/now/' + this.settings.id + '/',
            latitude: this.settings.lat,
            longitude: this.settings.lng,
            mapOptions: {
                currentPosition: (this.settings.profileLat && this.settings.profileLng),
                currentPositionCoordinates: {
                    latitude: this.settings.profileLat,
                    longitude: this.settings.profileLng
                },
                scroll: true,
                zoom: 13
            }
        });

        this.map.loadData(function(data) {
            that.map.render();
            that.unlock();
        });

        var categories = $('form input', '#today');

        categories.change(function() {
            if(that.locked) {
                $(this).attr('checked', true);
                return;
            }

            var allUnchecked = true;

            categories.each(function() {
                if($(this).is(':checked')) {
                    allUnchecked = false;
                    return false;
                }
            });

            if(allUnchecked) $(this).attr('checked', true);

            that.getSelectedCategories();
            that.filterMapEvents();
        });
    }

    filterMapEvents() {
        for(var i in this.map.mapEvents) {
            this.map.mapEvents[i].marker.setVisible(!($.inArray(this.map.mapEvents[i].categoryId, this.selectedCategories) < 0));
        }

        if(this.map.openedInfoWindow) {
            this.map.openedInfoWindow.close();
            this.map.openedInfoWindow = null;
        }
    }

    getSelectedCategories() {
        var categories = '';

        $('form input', '#today').each(function() {
            if($(this).is(':checked')) {
                categories += $(this).val() + ',';
            }
        });

        this.selectedCategories = categories.substr(0, categories.length - 1).split(',');
    }

    loadCalendarEvents(period) {
        var that = this;

        this.calendarPeriods.attr('disabled', true);
        this.calendarResults.html('<div class="loader"><i class="fas fa-circle-notch fa-spin"></i></div>');

        $.ajax({
            url: '/events/now/' + this.settings.id + '/load/?period=' + period,
            dataType: 'json',
            type: 'post',
            success: function(data) {
                that.calendarPeriods.attr('disabled', false);

                if(!data.success) {
                    that.calendarResults.html('<div class="empty">' + that.settings.translations.noEventsFound + '</div>');
                }
                else {
                    that.calendarResults.html(data.events);

                    $('li.expand a', that.calendarResults).click(function() {
                        var ul = $(this).parent().parent();
                        ul.addClass('transition').height((ul.find('li.item').length * 0.5) * 81 + 60);

                        $(this).parent().remove();
                        return false;
                    });
                }
            }
        });
    }

    calendarPeriodClickHandler(value) {
        if(this.locked) return;
        this.loadCalendarEvents(value);
    }

    rsvp(eventId) {
        if(this.locked) return;
        var that = this;

        profile.rsvp(eventId, 1, true, function() {
            $('li[data-id="' + eventId + '"] a.rsvp', that.calendarResults)
                .addClass('active')
                .text(that.settings.translations.attending)
                .attr('onclick', 'return false;');
        });
    }
}

export { City }
